import type { ConvertedToObjectType, TranslationJsonType } from './types';

export const translations: ConvertedToObjectType<TranslationJsonType> = {} as any;

export const convertLanguageJsonToObject = (
  json: any,
  objToConvertTo = translations,
  current?: string
) => {
  Object.keys(json).forEach((key) => {
    const currentLookupKey = current ? `${current}.${key}` : key;
    if (typeof json[key] === 'object') {
      // @ts-ignore
      objToConvertTo[key] = {};
      // @ts-ignore
      convertLanguageJsonToObject(json[key], objToConvertTo[key], currentLookupKey);
    } else {
      // @ts-ignore
      objToConvertTo[key] = currentLookupKey;
    }
  });
};
